export default {
  namespaced: true,
  state: {
    text: 'moduleA'
  },
  getter: {
    // 访问store根节点的数据state,通过rooteState这个参数来获取,注意rooteState必须是第三个参数
    detail (state, getters, rooteState) {
      return state.text + "-" + rooteState.name
    }
  },
  mutations: {},
  actions: {
    // callAction: {
    //   root: true,
    //   handler (namespacedContext, payload) {
    //     let { state, commit } = namespacedContext;
    //     commit('setText');
    //     alert(state.text);
    //   }
    // }
    callAction ({ state, rootState }) {
      alert(state.text + '-' + rootState.name);
    }
  }
}
